import React from 'react';
import { classnames } from '../../../../../../utils/classnames';
import ItemCardActionButton from '../itemCardActionButton/itemCardActionButton';
import './itemCardActions.css';

export default function ItemCardActions({ mainAction = null, infosAction = null }) {
    return (
        <div className={classnames('neo-item-card-actions')}>
            {infosAction && <ItemCardActionButton onlyIcon label={infosAction.label} icon={infosAction.icon} type={infosAction?.type || 'inverted'} onClick={infosAction.onClick}/>}
            {mainAction && <ItemCardActionButton label={mainAction.label} onClick={mainAction.onClick}/>}
        </div>
    )
}